<template>
  <div class="offline-session-single-time" @mouseenter='triggerHover()' @mouseleave='clearHover()'>
    <div v-if='time && time.time'>
      <div v-if='!average'> {{ displayTime }} </div>
      <div v-else><strong> {{ displayTime }} </strong></div>
    </div>
    <div v-else-if='time === undefined'> </div>
    <div v-else-if='time.time === 0'> - </div>

    <v-layout v-if='time !== undefined' justify-center>
      <!-- TODO: add more complex actions (like redoing a scramble, +2/DNF, comments, editing comments/time settings, delete time, etc.) -->
      <v-card v-if='hover && !average' class='hover'>
        <v-card-text>{{ scramble }}</v-card-text>
        <v-card-text>{{ scrambleDate }}</v-card-text>
        <v-btn text small @click='deleteSolve'>delete</v-btn>
        <v-btn text small @click='redoSolve'>redo</v-btn>
        <v-layout>
          <v-textarea v-if='!editingComment' v-model='time.comment' label='Comment' rows='3' auto-grow disabled></v-textarea>
          <v-textarea v-else v-model='newComment' label='Comment' rows='3' auto-grow></v-textarea>
          <v-layout column>
            <v-btn text small v-if='!editingComment' @click='toggleEdit'>edit</v-btn>
            <v-btn text small v-if='editingComment' @click='saveComment'>save</v-btn>
            <v-btn text small v-if='editingComment' @click='toggleEdit'>cancel</v-btn>
          </v-layout>
        </v-layout>
        <v-btn text small @click='solveOk'>OK</v-btn>
        <v-btn text small @click='solvePlusTwo'>+2</v-btn>
        <v-btn text small @click='solveDNF'>DNF</v-btn>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'offline-session-single-time',
  data () {
    return {
      editingComment: false,
      newComment: '',

      // setTimeout's timerID for clearing timeouts
      timerId: 0,
      hover: false
    }
  },
  props: {
    time: Object,
    solverId: String,
    scrambleId: String,
    scramble: String,
    average: Boolean
  },
  methods: {
    triggerHover () {
      if (window.innerWidth > 1080 && this.editingComment);
      else if (this.hover) clearTimeout(this.timerId)
      else {
        // timeout for open-delay of hover
        this.timerId = setTimeout(() => {
          this.hover = true
        }, 100)
      }
    },
    clearHover () {
      if (window.innerWidth > 1080 && this.editingComment);
      else if (!this.hover) clearTimeout(this.timerId)
      else {
        // timeout for close-delay of hover
        this.timerId = setTimeout(() => {
          this.hover = false
        }, 50)
      }
    },
    solveOk () {
      this.$emit('add-time', {
        time: {
          time: this.time.time,
          plusTwo: false,
          DNF: false,
          comment: this.time.comment
        },
        solverId: this.solverId,
        scrambleId: this.scrambleId
      })
    },
    solvePlusTwo () {
      this.$emit('add-time', {
        time: {
          time: this.time.time,
          plusTwo: true,
          DNF: false,
          comment: this.time.comment
        },
        solverId: this.solverId,
        scrambleId: this.scrambleId
      })
    },
    solveDNF () {
      this.$emit('add-time', {
        time: {
          time: this.time.time,
          plusTwo: false,
          DNF: true,
          comment: this.time.comment
        },
        solverId: this.solverId,
        scrambleId: this.scrambleId
      })
    },
    saveComment () {
      this.$emit('add-time', {
        time: {
          time: this.time.time,
          plusTwo: this.time.plusTwo,
          DNF: this.time.DNF,
          comment: this.newComment
        },
        solverId: this.solverId,
        scrambleId: this.scrambleId
      })
      this.time.comment = this.newComment
      this.editingComment = false
    },
    toggleEdit () {
      if (!this.editingComment) {
        this.editingComment = true
        this.$emit('open-dialog')
      } else {
        this.editingComment = false
        this.$emit('close-dialog')
      }
    },
    deleteSolve () {
      let res = confirm('You are about to delete this solve. THIS CANNOT BE UNDONE. Press OK to confirm')
      if (res) {
        this.$emit('add-time', {
          time: {
            time: 0,
            plusTwo: false,
            DNF: false,
            comment: ''
          },
          solverId: this.solverId,
          scrambleId: this.scrambleId
        })
      }
    },
    redoSolve () {
      this.$store.commit('setScrambleId', this.scrambleId)
      this.$store.commit('setScramble', this.scramble)
    }
  },
  computed: {
    scrambleDate () {
      if (!this.average) {
        return (new Date(parseInt(this.scrambleId.toString().substring(0, 8), 16) * 1000)).toLocaleString()
      }
      return undefined
    },
    displayTime () {
      if (this.time.time === Infinity || this.time.DNF) {
        return 'DNF'
      } else if (this.time.plusTwo) {
        return (this.time.time + 2).toFixed(2) + '+' + (this.time.comment ? '*' : '')
      } else {
        return this.time.time.toFixed(2) + (this.time.comment ? '*' : '')
      }
    }
  },
  watch: {
    hover () {
      this.editingComment = false
    }
  },
  created () {
    if (this.time) this.newComment = this.time.comment
  }
}
</script>

<style>
.v-card.hover {
  padding: 10px;
  position: absolute;
}
.v-card.hover > .v-card__text {
  padding: 5px;
}
@media only screen and (max-width: 1080px) {
  .v-card.hover {
    margin-left: 0px;
    left: 20vw;
    justify-content: center;
  }
}
</style>
